import {createStore, withProps} from '@ngneat/elf';
import {withRequestsStatus} from '@ngneat/elf-requests';

import {Statistics, StatisticsFilters, StatisticsMode} from '@store/statistics/statistics.model';

export const statisticsStore = createStore(
  {name: 'statistics'},
  withProps<Statistics>({
    filters: {
      mode: StatisticsMode.MONTH,
      date: new Date(),
      tableFilters: StatisticsFilters.initTableFilters(),
    },
    finance: {},
    operations: {},
  }),
  withRequestsStatus(),
);
